module.exports = __webpack_public_path__ + "static/media/B3.308961a2.webp";